export const ADD_COMPANY_OPTION = 'add-company';
export const ADD_COMPANY_SITE_OPTION = 'add-company-site';
